import React from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { sendingwines_support, vinologix_support } from "../config";
import AnimateWrapper from "../util/AnimateWrapper";

const CountryNotSupported = ({ usstate = false }) => {
    const { state } = useLocation();

    const contact = !state.countryFrom
        ? vinologix_support
        : state.countryFrom === "NL"
            ? vinologix_support
            : sendingwines_support;

    return (
        <AnimateWrapper>
            <h1>Verzenden naar {usstate ? "staat" : "land"} niet mogelijk</h1>
            <Card>
                <Card.Body className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <p className="my-0">
                        {usstate ? "De staat" : "Het land"} staat niet
                        in ons systeem, het is daarom niet mogelijk om alcoholische dranken te versturen naar {usstate ? "deze staat" : "dit land"} wegens douane restricties.
                    </p>
                </Card.Body>
            </Card>
        </AnimateWrapper>
    );
};

export default CountryNotSupported;
